import { render, staticRenderFns } from "./Creardocumento.vue?vue&type=template&id=9396ae98&scoped=true"
import script from "./Creardocumento.vue?vue&type=script&lang=js"
export * from "./Creardocumento.vue?vue&type=script&lang=js"
import style0 from "./Creardocumento.vue?vue&type=style&index=0&id=9396ae98&prod&lang=css"
import style1 from "@/assets/css/dropfile.css?vue&type=style&index=1&id=9396ae98&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9396ae98",
  null
  
)

export default component.exports